import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { LicenseBatchDto } from 'src/app/models/license.model';
import {
  DeviceSoftwareOverrideComponent,
  SoftwareOverridesSaved,
} from '../../device-license-manage-modal/device-software-override/device-software-override.component';

export interface LicenseBatchSoftwareOverrideModalData {
  batch: LicenseBatchDto;
}

@Component({
  selector: 'app-license-batch-software-override-modal',
  templateUrl: './license-batch-software-override-modal.component.html',
  styleUrls: ['./license-batch-software-override-modal.component.scss'],
  standalone: false,
})
export class LicenseBatchSoftwareOverrideModalComponent {
  @ViewChild(DeviceSoftwareOverrideComponent)
  softwareOverrideView?: DeviceSoftwareOverrideComponent;

  constructor(
    public dialogRef: DialogRef<SoftwareOverridesSaved>,
    @Inject(DIALOG_DATA) public data: LicenseBatchSoftwareOverrideModalData,
  ) {
    // Backdrop and Escape go through close() as well, so a save in flight is never cut off:
    // the server may still store it, and its response would be lost.
    dialogRef.disableClose = true;
    dialogRef.backdropClick
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.close());
    dialogRef.keydownEvents
      .pipe(
        filter((event) => event.key === 'Escape'),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.close());
  }

  get saving(): boolean {
    return !!this.softwareOverrideView?.saving;
  }

  get saveDisabled(): boolean {
    return !this.softwareOverrideView?.hasOverrideChanges || this.saving;
  }

  save(): void {
    this.softwareOverrideView?.saveOverrides();
  }

  close(overrides?: SoftwareOverridesSaved): void {
    if (this.saving) {
      return;
    }
    this.dialogRef.close(overrides);
  }
}
